export const CANVAS_PATHNAME = '/ai-assistant';
